import {exists} from '@aboutyou/utils';

const ROUTER_NOT_FOUND_ID = Symbol('ROUTER_NOT_FOUND_ID');

type NotFoundType = {
  __router_not_found_id__: typeof ROUTER_NOT_FOUND_ID;
};

export const createNotFoundHint = (): NotFoundType => {
  return {
    __router_not_found_id__: ROUTER_NOT_FOUND_ID,
  };
};

export const isNotFoundHint = (
  error: unknown | NotFoundType,
): error is NotFoundType => {
  return (
    exists(error) &&
    Object.prototype.hasOwnProperty.call(error, '__router_not_found_id__') &&
    (error as NotFoundType).__router_not_found_id__ === ROUTER_NOT_FOUND_ID
  );
};
